/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { GetGlycerinPriceFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { GetGlycerinPriceFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import type { getGlycerinPrice } from '.';

export const getGlycerinPriceDataMock: GetGlycerinPriceFragmentFragment = {
  value: 1337,
  valueOld: 13371337,
  currency: 'EUR',
};

export const getGlycerinPriceReturnMock: ReturnType<typeof getGlycerinPrice> = {
  displayedPrice: getGlycerinPriceDataMock.value,
  currency: getGlycerinPriceDataMock.currency,
  originalPrice: getGlycerinPriceDataMock.valueOld!,
};

export function getGetGlycerinPriceFragmentedData(data?: GetGlycerinPriceFragmentFragment) {
  return makeFragmentData(data || getGlycerinPriceDataMock, GetGlycerinPriceFragmentFragmentDoc);
}
